import React, { FC, useContext, useEffect } from 'react'
import useEditorActions from './useEditorActions'

import EditorContext from './EditorContext'
import CommandContext from './CommandContext'

interface CommandsProps {}

const Commands: FC<React.PropsWithChildren<CommandsProps>> = () => {
  const editorContext = useContext(EditorContext)
  const commandContext = useContext(CommandContext)

  const {
    exportLayout,
  } = useEditorActions()

  useEffect(() => {
    commandContext.setExtractor(() => {
      return exportLayout(editorContext.options)
    })
    return () => commandContext.removeExtractor()
  }, [])

  return null

}

export default Commands